
<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>  
      <v-col cols="12" sm="12">
        <v-text-field
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
// import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
// import CultureNew from "@models/cultures/new.vue"
import BaseUtil from "@shared_components/base_util.vue"
// import NewItemSelect from " /new_item_select.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    // MaskedTextField: MaskedTextField,
    // CultureNew: CultureNew,   
    BaseUtil: BaseUtil,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  watch: {
    
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>


